import {
    deleteRecordFile,
    DownloadUrlResponse,
    getRecordFileDownloadUrl,
    getUtilityFileDownloadUrl,
    listRecordFiles,
    listUtilityFiles,
    RecordFile,
    RecordFileType,
    uploadRecordFile,
} from '../../services/boxFilesService';

export type RecordFilesSource =
    | { kind: 'record'; type: RecordFileType; sfId: string }
    | { kind: 'utility'; accountId: string };

/** Stable identity for a source, so callers can pass an inline object literal. */
export const sourceKey = (source: RecordFilesSource): string =>
    source.kind === 'record'
        ? `record\u0000${source.type}\u0000${source.sfId}`
        : `utility\u0000${source.accountId}`;

export const listFiles = (source: RecordFilesSource): Promise<RecordFile[]> =>
    source.kind === 'record' ? listRecordFiles(source.type, source.sfId) : listUtilityFiles(source.accountId);

export const getDownloadUrl = (source: RecordFilesSource, fileId: string): Promise<DownloadUrlResponse> =>
    source.kind === 'record'
        ? getRecordFileDownloadUrl(source.type, source.sfId, fileId)
        : getUtilityFileDownloadUrl(source.accountId, fileId);

export const uploadFile = (source: RecordFilesSource, file: File): Promise<RecordFile> => {
    if (source.kind !== 'record') return Promise.reject(new Error('Uploads are only supported for records'));
    return uploadRecordFile(source.type, source.sfId, file);
};

export const deleteFile = (source: RecordFilesSource, fileId: string): Promise<void> => {
    if (source.kind !== 'record') return Promise.reject(new Error('Deletes are only supported for records'));
    return deleteRecordFile(source.type, source.sfId, fileId);
};
